// eslint-disable-next-line
export const isRichTextDocument = (value: any): boolean => {
  return (
    value &&
    typeof value === 'object' &&
    value.nodeType === 'document' &&
    Array.isArray(value.content)
  );
};

export const formatDateWithOrdinal = (dateStr: string) => {
  // Parse the date portion directly to avoid UTC timezone shift
  // (e.g. "2026-07-21T00:00+01:00" → UTC July 20th, but we want July 21st)
  const datePart = dateStr.split('T')[0];
  const [y, m, d] = datePart.split('-').map(Number);
  const day = d;
  const year = y;

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  function getOrdinal(n: number) {
    if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  }

  return `${getOrdinal(day)} ${monthNames[m - 1]} ${year}`;
};
